import { Caption } from "src/atoms/typography";

export const ResponsiveCaption = ({ ...rest }) => {
  return (
    <Caption
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow="ellipsis"
      fontSize={["10px", "14px", "16px"]}
      maxWidth={["40px", "56px", "64px"]}
      {...rest}
    />
  );
};
